import React from "react";
import logo from "../../assets/images/logo.svg";

const PrintOrderButton: React.FC = () => {
  const printOrderDetails = () => {
    const printElement = document.getElementById("order-details");

    if (printElement) {
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        // Extract data from the modal content
        const orderCode =
          printElement
            .querySelector("h2")
            ?.textContent?.replace("Order #", "") || "N/A";
        const orderStatus =
          printElement
            .querySelector(".bg-green-100, .bg-yellow-100, .bg-red-100")
            ?.textContent?.trim() || "Pending";
        const orderDate =
          printElement.querySelector(".text-sm.text-gray-500")?.textContent ||
          new Date().toLocaleString();

        // Extract order items from the actual structure
        const orderItems = Array.from(
          printElement.querySelectorAll(
            ".space-y-4.mb-6 .flex.border-b.border-gray-100.pb-4"
          )
        )
          .map((item) => {
            const name =
              item.querySelector("h4.font-medium")?.textContent ||
              "Unknown Item";
            const description =
              item.querySelector("p.text-sm.text-gray-500.mt-1")?.textContent ||
              "";
            const quantity =
              item
                .querySelector("span.text-sm")
                ?.textContent?.replace("Qty: ", "") || "1";
            const price =
              item.querySelector("p.font-semibold")?.textContent || "₦0";
            const totalPrice =
              item.querySelector("span.font-medium")?.textContent || "₦0";

            return `<div class="order-item">
            <div class="item-info">
              <div class="item-name">${name}</div>
              ${
                description
                  ? `<div class="item-description">${description}</div>`
                  : ""
              }
              <div class="item-quantity">Qty: ${quantity}</div>
            </div>
            <div class="item-price">
              <div class="price-per">${price}</div>
              <div class="price-total">${totalPrice}</div>
            </div>
          </div>`;
          })
          .join("");

        // Extract pricing information from the payment summary
        const paymentMethod =
          printElement.querySelector(
            ".bg-gray-50 .space-y-2 .flex.justify-between:first-child .font-medium"
          )?.textContent || "Cash";
        const subtotal =
          printElement.querySelector(
            ".bg-gray-50 .space-y-2 .flex.justify-between:nth-child(2) span:last-child"
          )?.textContent || "₦0";
        const deliveryFee =
          printElement.querySelector(
            ".bg-gray-50 .space-y-2 .flex.justify-between:nth-child(3) span:last-child"
          )?.textContent || "₦0";
        const serviceCharge =
          printElement.querySelector(
            ".bg-gray-50 .space-y-2 .flex.justify-between:nth-child(4) span:last-child"
          )?.textContent || "₦0";
        const total =
          printElement.querySelector(
            ".bg-gray-50 .border-t.border-gray-200.pt-2.mt-2.flex.justify-between.font-bold span:last-child"
          )?.textContent || "₦0";

        printWindow.document.write(`
          <html>
            <head>
              <title>Restaurant Order Receipt</title>
              <style>
                * {
                  margin: 0;
                  padding: 0;
                  box-sizing: border-box;
                }
                
                body {
                  font-family: 'Courier New', monospace;
                  line-height: 1.4;
                  color: #1f2937;
                  background: #f9fafb;
                  padding: 20px;
                  font-size: 12px;
                }
                
                .receipt {
                  max-width: 320px;
                  margin: 0 auto;
                  background: white;
                  border: 1px solid #d1d5db;
                  border-radius: 6px;
                  padding: 20px;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }
                
                /* Header */
                .receipt-header {
                  text-align: center;
                  border-bottom: 2px solid #d1d5db;
                  padding-bottom: 15px;
                  margin-bottom: 20px;
                  background: white;
                  color: #1f2937;
                  margin: -20px -20px 20px -20px;
                  padding: 20px;
                  border-radius: 5px 5px 0 0;
                }
                
                .restaurant-name {
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 5px;
                  text-transform: uppercase;
                  letter-spacing: 1px;
                }
                
                .receipt-title {
                  font-size: 13px;
                  margin-bottom: 5px;
                  opacity: 0.9;
                }
                
                .receipt-subtitle {
                  font-size: 10px;
                  opacity: 0.8;
                }
                
                .order-info {
                  font-size: 11px;
                  margin-bottom: 15px;
                  background: #f3f4f6;
                  padding: 12px;
                  border-radius: 4px;
                  border-left: 3px solid #374151;
                }
                
                .order-number {
                  font-weight: bold;
                  margin-bottom: 5px;
                  color: #111827;
                  font-size: 13px;
                }
                
                .order-status {
                  font-weight: bold;
                  text-transform: uppercase;
                  margin-bottom: 5px;
                  color: #059669;
                  font-size: 11px;
                }
                
                .order-date {
                  font-size: 10px;
                  color: #6b7280;
                }
                
                /* Items */
                .items-section {
                  margin: 20px 0;
                }
                
                .section-title {
                  font-weight: bold;
                  text-transform: uppercase;
                  border-bottom: 1px solid #d1d5db;
                  padding-bottom: 8px;
                  margin-bottom: 15px;
                  color: #374151;
                  font-size: 12px;
                  letter-spacing: 0.5px;
                }
                
                .order-item {
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 10px;
                  padding-bottom: 8px;
                  border-bottom: 1px solid #e5e7eb;
                  background: #f9fafb;
                  padding: 8px;
                  border-radius: 3px;
                }
                
                .order-item:last-child {
                  border-bottom: none;
                }
                
                .item-info {
                  flex: 1;
                }
                
                .item-name {
                  font-weight: bold;
                  margin-bottom: 3px;
                  color: #111827;
                  font-size: 12px;
                }
                
                .item-description {
                  font-size: 10px;
                  color: #6b7280;
                  margin-bottom: 3px;
                  font-style: italic;
                }
                
                .item-quantity {
                  font-size: 10px;
                  color: #374151;
                  font-weight: 600;
                }
                
                .item-price {
                  text-align: right;
                }
                
                .price-per {
                  font-size: 10px;
                  color: #6b7280;
                  margin-bottom: 2px;
                }
                
                .price-total {
                  font-weight: bold;
                  color: #111827;
                  font-size: 12px;
                }
                
                /* Pricing */
                .pricing-section {
                  border-top: 2px solid #374151;
                  padding-top: 15px;
                  margin-top: 20px;
                  background: #f3f4f6;
                  color: #111827;
                  margin: 20px -20px -20px -20px;
                  padding: 15px 20px;
                  border-radius: 0 0 5px 5px;
                }
                
                .pricing-row {
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 6px;
                  font-size: 11px;
                }
                
                .pricing-row.total {
                  font-size: 15px;
                  font-weight: bold;
                  border-top: 1px solid #d1d5db;
                  padding-top: 8px;
                  margin-top: 8px;
                  color: #111827;
                }
                
                .payment-method {
                  margin-top: 12px;
                  padding-top: 10px;
                  border-top: 1px solid #d1d5db;
                  font-size: 11px;
                }
                
                /* Footer */
                .receipt-footer {
                  text-align: center;
                  margin-top: 20px;
                  padding-top: 15px;
                  border-top: 1px solid #d1d5db;
                  font-size: 10px;
                  color: #6b7280;
                }
                
                .footer-text {
                  margin-bottom: 5px;
                }
                
                .thank-you {
                  font-weight: bold;
                  text-transform: uppercase;
                  margin-top: 10px;
                  color: #374151;
                  font-size: 11px;
                }
                
                .brand-logo {
                  width: 35px;
                  height: 35px;
                  background: rgba(255,255,255,0.1);
                  border-radius: 50%;
                  margin: 0 auto 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 16px;
                  font-weight: bold;
                  color: white;
                }
                
                /* Print Specific */
                @media print {
                  body {
                    background: white;
                    padding: 0;
                  }
                  .receipt {
                    border: 1px solid #d1d5db;
                    box-shadow: none;
                  }
                  .receipt-header { background: white !important; }
                  .pricing-section { background: #f3f4f6 !important; }
                }
              </style>
            </head>
            <body>
              <div class="receipt">
                <div class="receipt-header">
                  <div class="brand-logo">
                    <img src="${logo}" alt="Peak Reach" style="width: 100px; height: 100px;" />
                  </div>
                  <div class="receipt-title">Order Receipt</div>
                  <div class="receipt-subtitle">Food Delivery Service</div>
                </div>
                
                <div class="order-info">
                  <div class="order-number">Order #${orderCode}</div>
                  <div class="order-status">Status: ${orderStatus}</div>
                  <div class="order-date">Date: ${orderDate}</div>
                </div>
                
                <div class="items-section">
                  <div class="section-title">Order Items</div>
                  ${
                    orderItems ||
                    '<div class="order-item"><div class="item-info"><div class="item-name">No items found</div></div><div class="item-price"><div class="price-total">₦0</div></div></div>'
                  }
                </div>
                
                <div class="pricing-section">
                  <div class="pricing-row">
                    <span>Subtotal:</span>
                    <span>${subtotal}</span>
                  </div>
                  <div class="pricing-row">
                    <span>Delivery Fee:</span>
                    <span>${deliveryFee}</span>
                  </div>
                  <div class="pricing-row">
                    <span>Service Charge:</span>
                    <span>${serviceCharge}</span>
                  </div>
                  <div class="pricing-row total">
                    <span>TOTAL:</span>
                    <span>${total}</span>
                  </div>
                  
                  <div class="payment-method">
                    <div class="pricing-row">
                      <span>Payment Method:</span>
                      <span>${paymentMethod}</span>
                    </div>
                  </div>
                </div>
                
                <div class="receipt-footer">
                  <div class="footer-text">Thank you for your order!</div>
                  <div class="footer-text">Please keep this receipt</div>
                  <div class="thank-you">Enjoy your meal!</div>
                </div>
              </div>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      }
    } else {
      console.error("Order details element not found.");
    }
  };

  return (
    <button
      onClick={printOrderDetails}
      className="px-4 py-2 bg-blue-500 max-sm:whitespace-nowrap text-white rounded-lg shadow-md hover:bg-blue-600"
    >
      Print Order Details
    </button>
  );
};

export default PrintOrderButton;
